var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M23.356 15.88l.137.125a1.748 1.748 0 010 2.458L18.022 24l5.471 5.537c.634.641.67 1.65.112 2.334l-.126.138a1.707 1.707 0 01-2.293.097l-.122-.111-6.557-6.636a1.744 1.744 0 01-.5-1.358c-.036-.487.13-.986.5-1.36l6.557-6.636a1.707 1.707 0 012.292-.124zm8 0l.137.125a1.748 1.748 0 010 2.458L26.022 24l5.471 5.537c.634.641.67 1.65.112 2.334l-.126.138a1.707 1.707 0 01-2.293.097l-.122-.111-6.557-6.636a1.744 1.744 0 01-.5-1.358c-.036-.487.13-.986.5-1.36l6.557-6.636a1.707 1.707 0 012.292-.124z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
